import { AppointInfo } from './appoint/appointinfo/appointinfo';

export const PERSONNEL_INDEX = [
	AppointInfo
];



// WEBPACK FOOTER //
// ./src/pages/application/personnel/index.ts